module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('vue-menu', {
    on: {
      "snack": _vm.setSnackbar
    }
  }, [_c('div', {
    attrs: {
      "slot": "main-container"
    },
    slot: "main-container"
  }, [_c('router-view', {
    staticClass: "main-content"
  })], 1)]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.snackbarColor,
      "timeout": _vm.snackbarTimeout,
      "multi-line": "",
      "bottom": "",
      "right": ""
    },
    model: {
      value: (_vm.showSnackbar),
      callback: function($$v) {
        _vm.showSnackbar = $$v
      },
      expression: "showSnackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarMessage) + "\n      "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showSnackbar = false
      }
    }
  }, [_vm._v("\n        閉じる\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08a70db3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 479
// module chunks = 1